import { useTranslation } from "react-i18next";
import stepsStyles from "../steps.module.css";

export default function StepDireccion({ formData, setFormData, errors = {} }) {
  const { t } = useTranslation();

  function handleChange(field, value) {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }

  return (
    <div className="step">
      <h3 className="p-0 mt-2 mb-0 title" style={{ fontSize: "1.3rem" }}>
        {t("proveedores.direccionTitulo")}
      </h3>
      <p className={`${stepsStyles.inactive} mb-3`} style={{ fontSize: "1rem" }}>
        {t("proveedores.direccionSubtitulo")}
      </p>

      <div className={stepsStyles["form-wrapper"]}>
        <div className="form-group row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label">{t("common.provincia")}</label>
            <input
              type="text"
              className={`${stepsStyles["form-control"]} form-control`}
              placeholder="San José"
              value={formData.dir_provincia}
              onChange={(e) => handleChange("dir_provincia", e.target.value)}
            />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">{t("common.canton")}</label>
            <input
              type="text"
              className={`${stepsStyles["form-control"]} form-control`}
              placeholder="San José"
              value={formData.dir_canton}
              onChange={(e) => handleChange("dir_canton", e.target.value)}
            />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label">{t("common.distrito")}</label>
            <input
              type="text"
              className={`${stepsStyles["form-control"]} form-control`}
              placeholder="Carmen"
              value={formData.dir_distrito}
              onChange={(e) => handleChange("dir_distrito", e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">{t("proveedores.senasEspecificas")}</label>
          <textarea
            rows={3}
            className={`${stepsStyles["form-control"]} form-control`}
            placeholder={t("proveedores.senasPlaceholder")}
            value={formData.dir_senas}
            onChange={(e) => handleChange("dir_senas", e.target.value)}
            style={{ resize: "vertical" }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">{t("proveedores.observaciones")}</label>
          <textarea
            rows={3}
            className={`${stepsStyles["form-control"]} form-control`}
            placeholder={t("proveedores.observacionesPlaceholder")}
            value={formData.observaciones}
            onChange={(e) => handleChange("observaciones", e.target.value)}
            style={{ resize: "vertical" }}
          />
        </div>
      </div>
    </div>
  );
}
